import { Link, useLocation } from "react-router-dom";

const ContactFixButton = () => {

  const location = useLocation();
  console.log(location.pathname); // Outputs the current pathname

  
  return (
    <div>

      {
      location.pathname === "/thank-you" ?
      ""
      :
      <div className="contact-button">
        
      <div className="call-button">
      <Link title="Pet Grooming At Home" className="call-button-icon"  target="_blank" to="tel:+919658189189">
              <i class="fa-solid fa-phone-volume"></i>
          </Link>
    </div>


    <div className="whatsapp-button">
      <Link title="Cat Grooming Near Me" className="whatsapp-button-icon" target="_blank" to="https://wa.me/+919658189189?text=Hello ! I'm Interested in Doorstep Pet Grooming Service. Please contact me.">
        <i class="fa-brands fa-whatsapp"></i>
      </Link>
    </div>
        
      </div>
}


    </div>
  );
};

export default ContactFixButton;
